module.exports = __webpack_public_path__ + "img/honer14.d3c814bf.jpg";